/* Kite demo tiles: scales each fixed 350 × 273 card artboard to fit its tile
   (contain), centered. The background SVG covers the tile on its own.
   Uses offset sizes, not getBoundingClientRect, so the tile's hover scale is ignored. */
(function () {
  var frames = document.querySelectorAll('.kc-frame');
  if (!frames.length) return;

  function fit(frame) {
    var art = frame.querySelector('.kc-art');
    var w = frame.offsetWidth;
    var h = frame.offsetHeight;
    if (art && w && h) art.style.setProperty('--kc-scale', Math.min(w / 350, h / 273));
  }

  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        fit(entry.target);
      });
    });
    frames.forEach(function (frame) {
      ro.observe(frame);
    });
  }
  frames.forEach(fit);
})();
